import Vue from 'vue'
import axios from 'axios'
import Cookie from 'js-cookie'
import i18n from '@/i18n/index'

const isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1
const isiOS = !!navigator.userAgent.match(/\(i[^]+( U)? CPU.+Mac OS X/)

const iosDownloadUrl = 'https://itunes.apple.com/us/app/startimes/id1168518958?l=zh&ls=1&mt=8'
const androidDownloadUrl = 'https://startimes-apk-dl.startimes.me/lamda/apk-dl'
const permanentToken =
  'eyJhbGciOiJIUzUxMiJ9.eyJhcHAiOjIsInVpZCI6OTk5OSwiY2NvZGUiOiJORyIsInJvbGUiOjAsImRldiI6IjI5NTdhN2Y1LTk0YzYtNGUwMS04MmFjLWNmZjU1ZTgxZjIyOV9hcHAiLCJjcmVhdGVkIjoxNTY5NTc1NjI0OTIwLCJncHMiOjAsImV4cCI6MTg4NDkzNTYyNCwiY2lkIjoyfQ.-b_E0Kz42VuKaYUHMLUJ08bLXsk09ss9LLmg10pCRF0tG-VodPuhbaJpiwzdLrJCfqtR0vuKt83LF7buovmoOQ'

function randomString(len) {
  len = len || 32
  const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  let result = ''
  for (let i = len; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)]
  return result
}

let _jsBridge = {
  //https://github.com/marcuswestin/WebViewJavascriptBridge
  setupWebViewJavascriptBridge: callback => {
    if (isAndroid) {
      if (window.getChannelId) {
        return callback(window.getChannelId)
      } else {
        return callback(null)
      }
    } else if (isiOS) {
      if (window.WebViewJavascriptBridge) {
        return callback(window.WebViewJavascriptBridge)
      }
      if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback)
      }
      window.WVJBCallbacks = [callback]
      var WVJBIframe = document.createElement('iframe')
      WVJBIframe.style.display = 'none'
      WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__'
      document.documentElement.appendChild(WVJBIframe)
      setTimeout(() => {
        document.documentElement.removeChild(WVJBIframe)
      }, 0)
    } else {
      return callback(null)
    }
  },
  callHandler: (name, ...rest) => {
    //默认0.1秒超时
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        reject()
      }, 1500)
      _jsBridge.setupWebViewJavascriptBridge(bridge => {
        try {
          if (bridge) {
            if (isAndroid) {
              let response = null
              if (rest && rest.length > 0) {
                response = bridge[name].apply(bridge, rest)
              } else {
                response = bridge[name]()
              }
              if (response) {
                resolve(response)
              } else {
                resolve()
              }
            } else if (isiOS) {
              bridge.callHandler(name, rest[0], response => {
                if (response) {
                  resolve(response)
                } else {
                  resolve()
                }
              })
            } else {
              reject()
            }
          } else {
            reject()
          }
        } catch (error) {
          reject()
        }
      })
    })
  }
}

_jsBridge.setupWebViewJavascriptBridge(() => {})

let _clientInfo
// {
//   "client": "android",
//   "token": "eyJhbGciOiJIUzUxMiJ9",
//   "versionCode": "52500",
//   "versionName": "5.25",
//   "lnCode": "en",
//   "deviceId": "927677054c890edd0a67492691ebf7ee_android",
//   "network": "1",
//   "operator": "UNKNOWN",
//   "phoneModel": "GT-I9502",
//   "startTime": "1590484067349",
//   "uid": 111144292,
//   "countryCode": "NG",
//   "carrier": "MTN-NG",
//   "loginType": "Email",
//   "loginState": "l",
//   "isback": "0",
// }
// {
//   lnCode: 'en',
//   phoneModel: 'iPhone',
//   loginState: '1',
//   client: 'ios',
//   startTime: '1594611184753',
//   countryCode: 'MG',
//   versionName: '3.12',
//   uid: '111144385',
//   network: 'WiFi',
//   cid: 'UA-55969660-5',
//   token: 'eyJhbGciOiJIUzUxMiJ9',
//   deviceId: 'C4EB931A-7AFC-488D-AE34-BB333F9AB3CD_ios',
//   operator: '中国移动',
//   versionCode: '31200',
//   carrier: 'MTN-NG'
// }

const _client = {
  init() {
    //other methods must wait for init method complete
    return new Promise(resolve => {
      if (_clientInfo) {
        resolve(_clientInfo)
      } else {
        // support android>=5.20 || ios>=3.9
        _jsBridge
          .callHandler('jsGetHeadInfo')
          .then(info => {
            _clientInfo = JSON.parse(info)
            resolve(_clientInfo)
          })
          .catch(() => {
            // android<5.20, only get token
            _jsBridge
              .callHandler('getToken')
              .then(token => {
                _clientInfo = {}
                _clientInfo.client = 'android'
                _clientInfo.versionName = '5.19'
                _clientInfo.lnCode = navigator.language
                _clientInfo.deviceId = Cookie.get('_stdid')
                if (!_clientInfo.deviceId) {
                  _clientInfo.deviceId = randomString(32) + '_oldandoid'
                  Cookie.set('_stdid', _clientInfo.deviceId, { expires: 365, domain: '.startimestv.com' })
                }
                _clientInfo.token = token
                axios
                  .get('/cms/users/me', {
                    baseURL: process.env.VUE_APP_API_SERVER,
                    headers: {
                      token: _clientInfo.token
                    }
                  })
                  .then(res => {
                    let result = res.data || {}
                    if (result.roleName && result.roleName.toUpperCase() !== 'ANONYMOUS') {
                      _clientInfo.loginState = 'l'
                      _clientInfo.countryCode = result.countryCode
                      _clientInfo.uid = result.id
                    } else {
                      _clientInfo.loginState = 'a'
                    }
                    resolve(_clientInfo)
                  })
                  .catch(error => {
                    console.log(error)
                    _clientInfo.loginState = 'a'
                    resolve(_clientInfo)
                  })
              })
              .catch(() => {
                _clientInfo = {}
                _clientInfo.client = 'web'
                _clientInfo.versionName = ''
                _clientInfo.lnCode = navigator.language
                _clientInfo.deviceId = Cookie.get('_stdid')
                if (!_clientInfo.deviceId) {
                  _clientInfo.deviceId = randomString(32) + '_web'
                  Cookie.set('_stdid', _clientInfo.deviceId, { expires: 365, domain: '.startimestv.com' })
                }
                _clientInfo.token = Cookie.get('token')
                if (!_clientInfo.token) {
                  //default token
                  _clientInfo.token = permanentToken
                  _clientInfo.loginState = '0'
                  resolve(_clientInfo)
                } else {
                  axios
                    .get('/cms/users/me', {
                      baseURL: process.env.VUE_APP_API_SERVER,
                      headers: {
                        token: _clientInfo.token
                      }
                    })
                    .then(res => {
                      let result = res.data || {}
                      if (result.roleName && result.roleName.toUpperCase() !== 'ANONYMOUS') {
                        _clientInfo.loginState = '1'
                        _clientInfo.countryCode = result.countryCode
                        _clientInfo.uid = result.id
                      } else {
                        _clientInfo.loginState = '0'
                      }
                      resolve(_clientInfo)
                    })
                    .catch(error => {
                      console.log(error)
                      if (error.response.status == 401) {
                        if (window.location.origin.indexOf('webapp.startimestv.com') > 0) {
                          Cookie.remove('token', { domain: '.startimestv.com' })
                        } else if (window.location.origin.indexOf('webapp-test1.startimes.me') > 0) {
                          Cookie.remove('token', { domain: '.startimes.me' })
                        } else {
                          Cookie.remove('token')
                        }
                        window.alert('Your account is signed in elsewhere.')
                        window.location.reload()
                      }
                      _clientInfo.loginState = '0'
                      resolve(_clientInfo)
                    })
                }
              })
          })
      }
    })
  },
  getInfo() {
    return _clientInfo
  },
  isAndroid() {
    return _clientInfo.client.toLowerCase() == 'android'
  },
  isIOS() {
    return _clientInfo.client.toLowerCase() == 'ios'
  },
  isWeb() {
    return _clientInfo.client == 'web'
  },
  isLogin() {
    if (this.isAndroid()) {
      return _clientInfo.loginState == 'l' //l:login;a:anonymous;
    } else if (this.isIOS()) {
      return _clientInfo.loginState != '0' //0:anonymous;others:login;
    }
    return _clientInfo.loginState == '1'
  },
  callApp(params) {
    params = params || {}
    if (isiOS) {
      //startimes://platformapi/webtoapp
      window.location.href = iosDownloadUrl
    } else {
      let url = 'starvideo://platformapi/webtoapp'
      if (params.nextUrl) {
        if (params.nextUrl.startsWith('com.star.mobile.video')) {
          url += '?target=' + window.btoa(decodeURIComponent(params.nextUrl))
        } else {
          url += '?target=' + window.btoa('com.star.mobile.video.activity.BrowserActivity?loadUrl=' + params.nextUrl)
        }
      }
      window.location.href = url
      setTimeout(() => {
        if (!document.hidden) {
          let googleMarketUrl = 'market://details?id=com.star.mobile.video'
          let googleRef = '&referrer=' + params.referrer
          if (params.referrer && params.nextUrl) {
            if (params.nextUrl.startsWith('com.star.mobile.video')) {
              googleRef = '&referrer=' + encodeURIComponent(decodeURIComponent(params.referrer) + '&utm_term=' + params.nextUrl)
            } else {
              googleRef =
                '&referrer=' +
                encodeURIComponent(
                  decodeURIComponent(params.referrer) +
                    '&utm_term=' +
                    encodeURIComponent('com.star.mobile.video.activity.BrowserActivity?loadUrl=' + params.nextUrl)
                )
            }
          }
          googleMarketUrl += googleRef
          window.location.href = googleMarketUrl
          setTimeout(() => {
            if (!document.hidden) {
              window.location.href = androidDownloadUrl
            }
          }, 1000)
        }
      }, 1000)
    }
  },
  login(nextPageUrl) {
    if (this.isAndroid()) {
      let loginPageUrl = ''
      if (this.getInfo().versionCode < 60430) {
        loginPageUrl = 'com.star.mobile.video.account.LoginActivity'
      } else {
        loginPageUrl = 'com.star.mobile.video.account.PopupLoginActivity'
      }
      if (nextPageUrl) {
        loginPageUrl += '?returnClass=com.star.mobile.video.activity.BrowserActivity?loadUrl=' + nextPageUrl
      }
      _jsBridge.callHandler('toAppPage', 3, loginPageUrl, '')
    } else if (this.isIOS()) {
      if (nextPageUrl) {
        _jsBridge.callHandler('loginToTargetUrl', {
          targetUrl: nextPageUrl
        })
      } else {
        _jsBridge.callHandler('startLogin')
      }
    } else {
      if (window.location.origin.indexOf('webapp.startimestv.com') > 0) {
        window.location.href = '//m.startimestv.com/hybrid/account/signIn?pre=' + encodeURIComponent(window.location.href)
      } else {
        window.location.href = 'https://upms.startimes.me/hybrid/account/signIn?pre=' + encodeURIComponent(window.location.href)
      }
    }
  },
  gotoDVBPage() {
    if (this.isAndroid()) {
      _jsBridge.callHandler('toAppPage', 3, 'com.star.mobile.video.dvbservice.DvbServiceActivity', '')
    } else if (this.isIOS()) {
      _jsBridge.callHandler('toAppPage', {
        pageName: 'dvbActivationOTT'
      })
    } else {
      window.location.href = 'https://m.startimestv.com/hybrid/dvb/bind'
    }
  },
  gotoDVBBindPage() {
    if (this.isAndroid()) {
      _jsBridge.callHandler('toAppPage', 3, 'com.star.mobile.video.ottservice.dvbactivation.DvbLinkingActivity?needLogin=true', '')
    } else if (this.isIOS()) {
      _jsBridge.callHandler('toAppPage', {
        pageName: 'dvbLink'
      })
    } else {
      window.location.href = 'https://m.startimestv.com/hybrid/dvb/bind'
    }
  },
  gotoOTTPage() {
    if (this.isAndroid()) {
      _jsBridge.callHandler('toAppPage', 3, 'com.star.mobile.video.me.product.MembershipListActivity', '')
    } else if (this.isIOS()) {
      _jsBridge.callHandler('toAppPage', {
        pageName: 'ottProduct'
      })
    }
  },
  gotoOTTCoupon() {
    if (this.isAndroid()) {
      _jsBridge.callHandler('toAppPage', 3, 'com.star.mobile.video.me.coupon.OttCouponsActivity', '')
    } else if (this.isIOS()) {
      _jsBridge.callHandler('toAppPage', {
        pageName: 'coupon'
      })
    }
  },
  gotoDVBRecharge() {
    if (this.isAndroid()) {
      _jsBridge.callHandler('toAppPage', 3, 'com.star.mobile.video.smartcard.recharge.RechargeActivity', '')
    } else if (this.isIOS()) {
      _jsBridge.callHandler('toAppPage', {
        pageName: 'dvbRecharge'
      })
    }
  },
  play(id) {
    if (this.isAndroid()) {
      _jsBridge.callHandler('toAppPage', 3, 'com.star.mobile.video.player.PlayerVodActivity?vodId=' + id, '')
    } else if (this.isIOS()) {
      window.location.href = 'startimes://player?vodId=' + id
    } else {
      window.location.href = 'https://m.startimestv.com/browser/program/subdetail/' + id
    }
  },
  live(id) {
    if (this.isAndroid()) {
      _jsBridge.callHandler('toAppPage', 3, 'com.star.mobile.video.player.PlayerLiveActivity?channelID=' + id, '')
    } else if (this.isIOS()) {
      window.location.href = 'startimes://player?isLive=true&channelID=' + id
    }
  },
  tvguide(id) {
    if (this.isAndroid()) {
      _jsBridge.callHandler('toAppPage', 3, 'com.star.mobile.video.tvguide.ChannelDetailActivity?channelID=' + id, '')
    } else if (this.isIOS()) {
      window.location.href = 'startimes://player?isLive=true&channelID=' + id + '&liveStatus=0'
    }
  },
  me() {
    if (this.isAndroid()) {
      _jsBridge.callHandler('toAppPage', 3, 'com.star.mobile.video.home.HomeActivity?fragmentTag=Me', '')
    } else if (this.isIOS()) {
      window.location.href = 'startimes://me'
    }
  },
  topic(info) {
    if (this.isAndroid()) {
      _jsBridge.callHandler('toAppPage', 3, 'com.star.mobile.video.home.TopicPageActivity?code=' + info.code + '&title=' + info.title, '')
    } else {
      // iOS、web 调用此方法时无响应
    }
  },
  homeTab(code) {
    if (this.isAndroid()) {
      _jsBridge.callHandler('toAppPage', 3, 'com.star.mobile.video.home.HomeActivity?homeTabCode=' + code, '')
    } else if (this.isIOS()) {
      window.location.href = 'startimes://home?homeTabCode=' + code
    } else {
      // web
    }
  },
  share(params) {
    if (this.isIOS()) {
      _jsBridge.callHandler('shareContent', {
        url: params.url || '',
        content: params.content || '',
        title: params.title || '',
        imageUrl: params.imageUrl || ''
      })
    } else if (this.isAndroid()) {
      _jsBridge.callHandler(
        'showCustorm',
        params.content + params.url,
        params.url,
        params.url,
        params.url,
        params.url,
        params.url,
        params.url,
        params.imageUrl || '',
        params.title
      )
    }
  },
  toBrowser(url) {
    _jsBridge.callHandler('goOuterLink', url || '')
  },
  open(url) {
    if (this.isAndroid()) {
      _jsBridge.callHandler('toAppPage', 3, `com.star.mobile.video.activity.BrowserActivity?loadUrl=${encodeURIComponent(url)}`, '')
    } else if (this.isIOS()) {
      _jsBridge.callHandler('receiveRedirect', url)
    } else {
      // web
      window.location.href = url
    }
  },
  lang() {
    const lang = _clientInfo.lnCode
    if (lang == 'fr') {
      return i18n.fy
    } else if (lang == 'pt') {
      return i18n.py
    } else if (lang == 'sw') {
      return i18n.sy
    } else {
      return i18n.en
    }
  }
}

const Client = {
  install: Vue => {
    // window.client = _client
    Vue.client = _client
    Vue.prototype.$client = _client
  }
}

Vue.use(Client)

export default Client
